import type { NewsMediaOrganization } from 'schema-dts';
import { siteName, siteUrl } from '$lib/config';

export default function getPublisher(): NewsMediaOrganization {
  return {
    '@type': 'NewsMediaOrganization',
    name: siteName,
    logo: `${siteUrl}/logo-1024x576.png`,
  };
}
